import styled from 'styled-components';
import {StyledButton} from "../../../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const StyledOkButton = styled(StyledButton)`
    min-width: 20rem;
    max-width: 24rem;
    align-self: center;

    @media only screen and (min-width: 900px) {
        margin-top: 2rem !important;
    }
`
export const StyledDescription = styled.div`
    font-size: 1rem;
    text-align: center;
    margin-bottom: 2rem;
`